module.exports = __webpack_public_path__ + "img/logo-oppo.1f898983.jpg";